import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { conf } from '../../../../confg';
import { ROUTES } from '../../constant/Routes';

const DEFAULT_BANNER = {
  text: '! برای دیدن قیمت همکار کلیک کنید',
  link: ROUTES.PERSONAL_INFO,
  bg_color: '#01494b',
  text_color: '#fff',
};

/**
 * بنر دعوت به قیمت همکار داخل هدر — از GET /api/colleague-banner
 */
const ResponsiveBannerForCollogue = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios({ url: `${conf.server_url}colleague-banner`, method: 'GET' })
      .then((res) => {
        if (cancelled) return;
        const data = res?.data?.data;
        if (data?.enabled && data?.text) {
          setBanner({
            text: data.text,
            link: (data.link || '').trim() || ROUTES.PERSONAL_INFO,
            bg_color: data.bg_color || DEFAULT_BANNER.bg_color,
            text_color: data.text_color || DEFAULT_BANNER.text_color,
          });
        } else {
          setBanner(null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          // در صورت خطای API همان متن قبلی را نشان بده تا هدر خالی نشود
          setBanner(DEFAULT_BANNER);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!banner) return null;

  const href = (banner.link || ROUTES.PERSONAL_INFO).trim();
  const isExternal = /^https?:\/\//i.test(href);

  return (
    <div className='gold-banner-container'>
      <div className='gold-banner-wrapper'>
        <a
          href={href}
          className='gold-banner-content'
          style={{
            backgroundColor: banner.bg_color,
            color: banner.text_color,
            display: 'block',
            textDecoration: 'none',
          }}
          target={isExternal ? '_blank' : undefined}
          rel={isExternal ? 'noopener noreferrer' : undefined}
        >
          <h1
            className='gold-banner-heading'
            style={{
              color: banner.text_color,
            }}
          >
            {banner.text}
          </h1>
        </a>
      </div>
    </div>
  );
};

export default ResponsiveBannerForCollogue;
